// Compte relu à la fin d'un cours (terminé ou annulé). Pendant un cours, le serveur note
// l'élève (et le prof) « en cours » (online 2) : la recherche affiche alors « Terminez
// votre cours actuel » à la place de « Prendre un cours ». À la fin, le serveur le remet
// à 1, mais le site gardait l'ancien compte : l'élève absent de la salle à ce moment-là
// (parti avec « Quitter », sur une autre page) restait bloqué, même chez un autre prof,
// jusqu'au rechargement de la page.
// Aussi relu après une reconnexion du socket : une fin de cours survenue pendant la
// coupure (onglet en arrière-plan, réseau) n'arrive jamais.
// Renvoie la fonction qui arrête le suivi.
export const CLASS_END_EVENTS = ["class-completed", "class-cancelled"];

export const keepAccountInSync = (socket, refresh) => {
  let connectedBefore = socket.connected;
  const onClassEnd = () => refresh();
  // Première connexion : le compte vient d'être chargé avec la page
  const onConnect = () => {
    if (connectedBefore) refresh();
    connectedBefore = true;
  };
  CLASS_END_EVENTS.forEach((event) => socket.on(event, onClassEnd));
  socket.on("connect", onConnect);
  return () => {
    CLASS_END_EVENTS.forEach((event) => socket.off(event, onClassEnd));
    socket.off("connect", onConnect);
  };
};
